<template>
    <div class="menu-right">
        <!-- <p class="title">Rutas de un GXSV</p> -->
        <div class="menu">
            <div class="text" :style="heightText">
                <img src="@/assets/imgs/rutagxsv.png" alt="">
            </div>
            <div class="downloads">
                <div class="img">
                    <img src="@/assets/imgs/descargalasya.svg" alt="">
                </div>
                <div class="downloads-content">
                    <div class="number" @click="goTo('pdfs/01.ruta1-comic.pdf')">
                        <div class="number-content">
                            <img src="@/assets/imgs/1.svg" alt="" class="animated tada">
                        </div>
                    </div>
                    <div class="number" @click="goTo('pdfs/02.ruta2-comic.pdf')">
                        <div class="number-content">
                            <img src="@/assets/imgs/2.svg" alt="" class="animated tada">
                        </div>
                    </div>
                    <div class="number" @click="goTo('pdfs/03.ruta3-comic.pdf')">
                        <div class="number-content">
                            <img src="@/assets/imgs/3.svg" alt="" class="animated tada">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'side-bar-right',
        data() {
            return {
                heightText: {
                    maxHeight: `calc(100% - 76px - 190px)`
                }
            }
        },
        mounted() {
            this.$root.$on('footer-height', res => {
                console.log('Res', res)
                this.heightText = {
                    maxHeight: `calc(100% - 76px - 190px - ${res}px)`
                }
            })
        },
        methods: {
            goTo(url) {
                window.open(url, '_blank')
            }
        },
    };
</script>

<style lang="sass" scoped>
    .menu-right
        height: 100%
        position: relative
        bottom: 0
        width: 100%
        left: 50%
        transform: translateX(-50%)
        max-height: 100%
        .menu
            list-style: none
            padding-left: 0
            position: absolute
            top: 50%
            transform: translateY(-50%)
            width: 90%
            text-align: center
            max-height: 100%
            margin: 0
            .text
                height: 350px
                max-height: calc(100% - 76px - 175px)
                img
                    height: 100%
                    max-height: 100%
            .downloads
                height: 100%
                width: 100%
                margin-top: 5px
                position: relative
                .img
                    position: absolute
                    height: 150px
                    display: inline-block
                    width: auto
                    left: -55%
                    box-sizing: border-box
                    padding-right: 5px
                    img
                        width: auto
                        height: 100%
                .downloads-content
                    display: inline-block
                    width: 100%
                    .text
                        padding: 1px
                        height: auto
                        max-height: calc(100% - 180px - 85px)
                        img
                            width: auto
                            height: auto
                            max-width: 100%
                            max-height: calc(100% - 180px - 85px)
                    .number
                        width: 100%
                        height: 45px
                        margin-top: 7.5px
                        position: relative
                        .number-content
                            cursor: pointer
                            background: #f07b7f
                            border-radius: 3em
                            text-align: center
                            margin-bottom: 8px
                            transition: all .4s ease-in-out
                            -webkit-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, .3)
                            -moz-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, .3)
                            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, .3)
                            height: 100%
                            width: 100%
                            position: relative
                            box-sizing: border-box
                            &:hover
                                background: #C0767B
                            img
                                width: auto
                                max-height: 30px
                                margin: 5px auto

        .title
            color: white
            position: absolute
            transform: rotate(-90deg) translateX(-50%)
            transform-origin: center
            margin: 0
            padding: 0
            width: auto
            height: auto
            white-space: nowrap
            bottom: 368px
            right: -75px
            font-size: 1.5em
            z-index: 2
            @media only screen and (max-height: 480px)
                display: none

        .animated
            animation-iteration-count: infinite

</style>
